const reservationsModule = {
    namespaced: true,
    state: {
        currentReservation: null,
        userData: null,
        consents: null,
        payment: null,
        checked: [],
        paymentReservations: [] 
    },
    actions: {
        setReservation({commit}, reservation) {
            commit('setReservation', reservation);
        },
        clearReservation({commit}) {
            commit('clearReservation');
        },
        setChecked({commit}, checked) {
            commit('setChecked', checked)
        },
        clearChecked({commit}) {
            commit('setChecked', []);
        },
        setPayment({commit}, payment) {
            commit('setPayment', payment);
        },
        clearPayment({commit}) {
            commit('setPayment', null);
        },
        setPaymentReservations({commit}, paymentReservations) {
            commit('setPaymentReservations', paymentReservations);
        },
        clearPaymentReservations({commit}) {
            commit('setPaymentReservations', []);
        },
        togglePaymentReservationsItem({commit}, paymentReservation) {
            commit('togglePaymentReservationsItem', paymentReservation);
        }
    },
    getters: {
        getReservation(state) {
            return state.currentReservation;
        },
        getChecked(state) {
            return state.checked;
        },
        getPayment(state) {
            return state.payment;
        },
        getPaymentReservations(state) {
            return state.paymentReservations;
        }
    },
    mutations: {
        setReservation(state, reservation) {
            state.currentReservation = reservation;
        },
        setChecked(state, checked) {
            state.checked = checked;
        },
        setPayment(state, payment) {
            state.payment = payment;
        },
        clearReservation(state) {
            state.currentReservation = null;
        },
        setPaymentReservations(state, paymentReservations) {
            state.paymentReservations = paymentReservations;
        },
        togglePaymentReservationsItem(state, paymentReservation) {
            if (state.paymentReservations.find(i => i.reservation_id == paymentReservation.reservation_id)) {
                state.paymentReservations = state.paymentReservations.filter(i => i.reservation_id != paymentReservation.reservation_id);
            } else {
                state.paymentReservations = [paymentReservation].concat(state.paymentReservations)
            }
        }
    }
}

export default reservationsModule;